import registerAuth from './registerAuth'
import registerRecord from "./registerRecord";
import signRecord from "./signRecord";

const RegisterServer = {
    registerAuth,
    registerRecord,
    signRecord,
};

export default RegisterServer;
